import Axios from 'axios'

const serviceRequest = {
  getServicesRequest (date) {
    return Axios.get(`api/suppliers/requests?date=${date}`)
  },
  approveRequest (request, roomIds) {
    const serviceIds = Array.isArray(request.serviceIds) ? request.serviceIds : [request.serviceId]
    return Axios.put(
      `api/suppliers/clients/${request.clientId}/events/${request.eventId}/services/approve`,
      { serviceIds, roomIds }
    )
  },
  rejectRequest (request, roomIds) {
    const serviceIds = Array.isArray(request.serviceIds) ? request.serviceIds : [request.serviceId]
    return Axios.put(
      `api/suppliers/clients/${request.clientId}/events/${request.eventId}/services/reject`,
      { serviceIds, roomIds }
    )
  },
  getReport (startDate, endDate) {
    let headers = {responseType: 'arraybuffer'}
    return Axios.get(`/api/suppliers/requests/reports/file?startDate=${startDate}&endDate=${endDate}`, headers)
  },
}

export default serviceRequest
